export const categories = [
  { slug: 'jiese-fangfa', name: '戒色方法', icon: 'ri-lightbulb-line', description: '科学系统的戒色方法论与实操指南' },
  { slug: 'xinli-tiaojie', name: '心理调节', icon: 'ri-heart-pulse-line', description: '心理层面的调节技巧与认知重建' },
  { slug: 'chenggong-anli', name: '成功案例', icon: 'ri-trophy-line', description: '真实戒色成功者的经验分享' },
  { slug: 'shenti-bianhua', name: '身体变化', icon: 'ri-body-scan-line', description: '戒色后身体各项指标的积极变化' },
  { slug: 'jiese-daka', name: '戒色打卡', icon: 'ri-calendar-check-line', description: '每日打卡记录与社群互相监督' },
];

export const articles = [
  {
    id: '1',
    slug: 'kexue-jiese-rumen-zhinan',
    title: '科学戒色入门指南：从零开始的自律之路',
    excerpt: '戒色不是靠意志力硬撑，而是需要科学的方法和正确的认知。本文为你梳理一套系统化的戒色入门方案。',
    content: `
<h2>为什么戒色需要科学方法？</h2>
<p>很多人以为戒色就是"忍"，咬着牙坚持就完了。但实际上，单纯依靠意志力的戒色方式失败率极高。科学研究表明，色情成瘾与大脑的奖励机制密切相关——频繁的色情刺激会改变多巴胺系统的敏感度，形成类似物质成瘾的神经回路。</p>
<p>因此，戒色本质上是一场"大脑重塑"的过程，需要从认知、行为、环境三个层面同时入手，才能真正打破成瘾循环。</p>

<h2>第一步：认知重塑</h2>
<p>戒色的第一步不是"戒"，而是"知"。你需要清楚地了解：</p>
<ul>
<li><strong>色情如何影响大脑：</strong>过度色情刺激会导致多巴胺受体下调，使你对日常生活中的快乐变得麻木。</li>
<li><strong>戒断反应是正常的：</strong>在戒色初期，焦虑、失眠、情绪波动都是大脑在修复的正常表现，不要因此放弃。</li>
<li><strong>你不是一个人在战斗：</strong>全球有数百万人在进行同样的努力，这是一个被科学验证可以有效改善的领域。</li>
</ul>

<h2>第二步：行为替代</h2>
<p>单纯"不做什么"很难成功，你需要"做什么"来填补空缺：</p>
<ul>
<li><strong>运动：</strong>每天至少30分钟有氧运动，能有效提升内啡肽和多巴胺水平。</li>
<li><strong>冥想：</strong>每天10-15分钟正念冥想，帮助提升自我觉察能力。</li>
<li><strong>新爱好：</strong>学习一门新技能或培养一个新爱好，给大脑提供健康的奖励来源。</li>
</ul>

<h2>第三步：环境管理</h2>
<p>你的环境决定了你戒色的难度：</p>
<ul>
<li>在手机和电脑上安装内容过滤软件。</li>
<li>睡前将手机放在卧室外充电。</li>
<li>避免独处时的无聊状态，提前安排好每天的时间表。</li>
<li>加入戒色社群，找到志同道合的伙伴互相监督。</li>
</ul>

<h2>戒色时间线参考</h2>
<p>根据大量戒色成功者的经验总结，以下是一个大致的时间线：</p>
<ul>
<li><strong>第1-7天：</strong>戒断反应最强烈的时期，需要最大的毅力支撑。</li>
<li><strong>第7-21天：</strong>戒断反应逐渐减弱，开始感受到精力提升。</li>
<li><strong>第21-60天：</strong>大脑修复加速期，专注力、记忆力明显改善。</li>
<li><strong>第60-90天：</strong>进入稳定期，自律能力显著增强。</li>
<li><strong>90天以上：</strong>进入新常态，色情刺激的吸引力大幅下降。</li>
</ul>
`,
    category: 'jiese-fangfa',
    categoryName: '戒色方法',
    author: '戒色指南编辑部',
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Serene%20meditation%20scene%20in%20a%20sunlit%20room%20with%20warm%20natural%20light%2C%20minimalist%20aesthetic%2C%20person%20sitting%20peacefully%20in%20lotus%20pose%2C%20soft%20beige%20and%20cream%20tones%2C%20calm%20atmosphere%2C%20zen%20interior%20with%20wooden%20floors%20and%20a%20small%20plant%2C%20editorial%20photography%20style&width=800&height=450&seq=jiese-article-1&orientation=landscape',
    tags: ['戒色入门', '科学方法', '自律'],
    featured: true,
  },
  {
    id: '2',
    slug: 'jiese-30tian-shenti-bianhua',
    title: '戒色30天后，身体会发生哪些惊人变化？',
    excerpt: '戒色30天是很多人的第一个里程碑。从精力、睡眠到皮肤状态，身体会有一系列积极的变化。',
    content: `
<h2>戒色30天的身体蜕变</h2>
<p>戒色30天是一个非常重要的节点。在这个时间点上，大多数人的戒断反应已经大幅减弱，而身体的积极变化开始显现。以下是基于大量戒色者反馈总结的身体变化。</p>

<h2>精力水平的变化</h2>
<p>戒色7天后，很多人报告精力开始回升。到了30天，这种改善变得更加明显：</p>
<ul>
<li>早晨起床更加轻松，不再需要反复按闹钟。</li>
<li>白天的困倦感显著减少，下午不再需要咖啡提神。</li>
<li>整体工作效率提升约20-30%。</li>
</ul>

<h2>睡眠质量的改善</h2>
<p>频繁色情刺激会扰乱褪黑素的正常分泌。戒色30天后：</p>
<ul>
<li>入睡时间从平均40分钟缩短到15-20分钟。</li>
<li>深度睡眠时间增加，做梦变得更加清晰。</li>
<li>早晨醒来感觉更加"睡饱了"。</li>
</ul>

<h2>皮肤状态</h2>
<p>这是一个很多人意想不到的变化。戒色后体内雄性激素水平趋于稳定：</p>
<ul>
<li>面部出油减少，痘痘明显改善。</li>
<li>皮肤光泽度提升，暗沉感消失。</li>
<li>黑眼圈变淡（与睡眠改善也有关系）。</li>
</ul>

<h2>心理层面的变化</h2>
<ul>
<li><strong>焦虑感下降：</strong>不再为"又破戒了"而自责，自我效能感提升。</li>
<li><strong>注意力提升：</strong>能够更长时间地专注于一件事。</li>
<li><strong>社交意愿增强：</strong>更愿意主动与人交流，眼神接触更加自然。</li>
</ul>
`,
    category: 'shenti-bianhua',
    categoryName: '身体变化',
    author: '戒色指南编辑部',
    date: '2026-08-08',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Healthy%20male%20silhouette%20running%20outdoors%20at%20sunrise%2C%20golden%20hour%20lighting%2C%20fitness%20and%20vitality%20concept%2C%20clean%20minimalist%20composition%2C%20warm%20beige%20and%20cream%20background%2C%20athletic%20aesthetic%2C%20soft%20natural%20light%2C%20inspirational%20mood&width=800&height=450&seq=jiese-article-2&orientation=landscape',
    tags: ['身体变化', '30天', '精力'],
    featured: true,
  },
  {
    id: '3',
    slug: 'xinli-renzhi-xingwei-liaofa',
    title: '认知行为疗法在戒色中的应用',
    excerpt: 'CBT（认知行为疗法）是治疗成瘾行为最有效的心理方法之一。本文详解如何用CBT技巧辅助戒色。',
    content: `
<h2>什么是认知行为疗法（CBT）？</h2>
<p>认知行为疗法是一种以实证为基础的心理治疗方法，其核心理念是：我们的情绪和行为不是由事件本身直接引起的，而是由我们对事件的"认知"（想法、信念）所决定的。</p>
<p>在戒色中，这意味着：触发你想看色情内容的不是某个外部刺激本身，而是你对这个刺激的"自动思维"。</p>

<h2>CBT在戒色中的具体应用</h2>

<h3>1. 识别自动思维</h3>
<p>当你有"想看"的冲动时，试着记录下脑海中闪过的想法：</p>
<ul>
<li>"就看这一次，没关系的。"</li>
<li>"今天太累了，需要放松一下。"</li>
<li>"反正也戒不了，不如放弃算了。"</li>
</ul>
<p>这些就是需要被挑战的自动思维。</p>

<h3>2. 挑战扭曲认知</h3>
<p>针对每一个自动思维，用理性来反驳：</p>
<ul>
<li>"就看这一次" → "每一次破戒都是从'就看这一次'开始的。"</li>
<li>"需要放松" → "运动、冥想、阅读才能真正放松，色情只是暂时的逃避。"</li>
<li>"戒不了" → "数以万计的人已经成功了，他们的方法我也可以学习。"</li>
</ul>

<h3>3. 行为实验</h3>
<p>设计小的行为实验来验证你的新认知。比如：当冲动来临时，先做20个俯卧撑，观察冲动是否减弱。你会发现，大多数冲动持续不超过10-15分钟。</p>
`,
    category: 'xinli-tiaojie',
    categoryName: '心理调节',
    author: '戒色指南编辑部',
    date: '2026-08-05',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20therapy%20room%20with%20two%20comfortable%20chairs%2C%20soft%20diffused%20natural%20light%20streaming%20through%20sheer%20curtains%2C%20neutral%20beige%20and%20cream%20color%20palette%2C%20peaceful%20atmosphere%2C%20wooden%20floor%2C%20small%20desk%20with%20a%20notebook%2C%20professional%20yet%20warm%20setting&width=800&height=450&seq=jiese-article-3&orientation=landscape',
    tags: ['CBT', '认知行为疗法', '心理调节'],
    featured: false,
  },
  {
    id: '4',
    slug: '90tian-jiese-chenggong-jingyan',
    title: '90天戒色成功者访谈：他是如何做到的？',
    excerpt: '我们采访了一位成功戒色超过90天的朋友，听听他的真实心路历程和实用经验。',
    content: `
<h2>访谈背景</h2>
<p>小李（化名），28岁，程序员，从大学时期开始有过度色情消费的习惯。在多次尝试戒色失败后，他调整了策略，最终成功坚持超过90天。以下是他的真实分享。</p>

<h2>Q：是什么让你下定决心戒色的？</h2>
<p>"有一天我连续工作了4个小时后，发现自己完全无法集中注意力。我意识到这不仅是自律的问题——我的大脑好像被什么东西'绑架'了。那天晚上我没看任何色情内容，第二天早上醒来，我第一次感受到了什么叫'清醒'。"</p>

<h2>Q：之前失败过几次？为什么这次成功了？</h2>
<p>"之前至少失败了20多次。但这一次不一样，因为我做了三件事：第一，我加入了一个戒色社群，每天打卡；第二，我删除了所有社交媒体上的触发内容；第三，我开始跑步，每周至少跑三次。"</p>

<h2>Q：最难熬的是哪段时间？</h2>
<p>"第3天到第10天。那段时间几乎每晚都失眠，情绪波动很大。但过了第10天之后，一切开始好转。我现在可以负责任地说，最难的就是前两周，撑过去就成功了一半。"</p>

<h2>Q：对正在戒色的朋友，你有什么建议？</h2>
<p>"不要把戒色当成一种'牺牲'。把它当成一种'投资'——你投资的是未来的精力、专注力和自信心。另外，找一个'为什么'比找一个'怎么做'更重要。当你知道为什么要戒色，方法自然会浮现。"</p>
`,
    category: 'chenggong-anli',
    categoryName: '成功案例',
    author: '戒色指南编辑部',
    date: '2026-08-03',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Young%20professional%20man%20sitting%20confidently%20at%20a%20modern%20workspace%2C%20natural%20light%20from%20large%20window%2C%20calm%20and%20focused%20expression%2C%20minimalist%20office%20with%20plants%2C%20warm%20beige%20and%20cream%20tones%2C%20success%20and%20achievement%20mood%2C%20editorial%20portrait%20photography&width=800&height=450&seq=jiese-article-4&orientation=landscape',
    tags: ['成功案例', '90天', '经验分享'],
    featured: true,
  },
  {
    id: '5',
    slug: 'jiese-daka-zhongyaoxing',
    title: '戒色打卡为什么重要？科学依据与实操方法',
    excerpt: '每日打卡不仅是记录，更是一种强大的行为塑造工具。了解打卡背后的心理学原理和最佳实践。',
    content: `
<h2>打卡的科学原理</h2>
<p>你一定听过"21天养成一个习惯"这个说法。虽然实际上习惯养成的时间因人而异（研究表明平均需要66天），但核心原理是正确的：<strong>持续的行为重复会重塑大脑的神经通路</strong>。</p>
<p>打卡之所以有效，背后有几个关键心理学机制：</p>

<h2>1. 承诺一致性原理</h2>
<p>当你公开宣布自己要戒色并在社群里每天打卡时，你的大脑会产生一种"保持一致"的内在压力。这种压力是积极的，它会推动你坚持自己的承诺。</p>

<h2>2. 即时反馈循环</h2>
<p>每完成一次打卡，大脑会释放少量多巴胺作为奖励。这种即时的正面反馈与传统色情刺激形成了替代关系——你在用健康的奖励机制替代不健康的奖励机制。</p>

<h2>3. 社交监督效应</h2>
<p>在社群中打卡意味着你不是一个人。其他人的进步会激励你，你的进步也会激励别人。这种双向的正向循环是戒色社群的核心价值。</p>

<h2>如何有效打卡</h2>
<ul>
<li><strong>固定时间：</strong>每天在同一个时间点打卡，形成条件反射。</li>
<li><strong>不只是"签到"：</strong>写下当天的感受、遇到的困难和克服的方法。</li>
<li><strong>设定里程碑奖励：</strong>每完成7天、21天、60天给自己一个小奖励。</li>
<li><strong>不要因为断了一天就放弃：</strong>连续性很重要，但偶尔中断不代表失败。</li>
</ul>
`,
    category: 'jiese-daka',
    categoryName: '戒色打卡',
    author: '戒色指南编辑部',
    date: '2026-08-01',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20minimalist%20checklist%20and%20calendar%20on%20a%20clean%20wooden%20desk%2C%20warm%20morning%20sunlight%2C%20pen%20and%20notebook%2C%20organized%20and%20peaceful%20workspace%2C%20soft%20beige%20and%20cream%20tones%2C%20productivity%20and%20habit%20tracking%20concept%2C%20flat%20lay%20style&width=800&height=450&seq=jiese-article-5&orientation=landscape',
    tags: ['打卡', '习惯养成', '社群'],
    featured: false,
  },
  {
    id: '6',
    slug: 'mingxiang-jiese-xianghu-guangxi',
    title: '正念冥想与戒色：如何用觉知打破自动化反应',
    excerpt: '正念冥想是戒色工具箱中最强大的武器之一。学会用觉知力识别冲动，而不是被冲动控制。',
    content: `
<h2>冲动的本质</h2>
<p>每一次"想看"的冲动，本质上是一个自动化反应链条：<strong>触发物 → 自动思维 → 情绪反应 → 行为</strong>。通常情况下，这个链条在几秒钟内就完成了，快到我们几乎意识不到中间发生了什么。</p>
<p>正念冥想的核心价值就在于：<strong>在"冲动产生"和"行为执行"之间插入一个"觉察的空间"</strong>。</p>

<h2>正念应对冲动的三步法</h2>

<h3>第一步：识别（Recognize）</h3>
<p>当冲动出现时，不要对抗，不要评判。只是简单地对自己说："此刻，我感到了一种冲动。"</p>
<p>这种客观的观察态度本身就能降低冲动的强度。研究表明，仅仅给情绪命名就能降低杏仁核的活跃度。</p>

<h3>第二步：接纳（Accept）</h3>
<p>很多人以为正念是"清空大脑"，但这是误解。正念的核心是"如其所是地接纳当下的一切体验"，包括不舒服的冲动。</p>
<p>试着把冲动想象成一片云，你看着它飘过来，你不需要推开它，也不需要抓住它——只是看着它慢慢地飘过。</p>

<h3>第三步：观察（Observe）</h3>
<p>用好奇心观察这个冲动：它在身体的哪个部位？是一种什么感觉？紧张？发热？心跳加速？</p>
<p>当你把注意力从"冲动的对象"转移到"冲动本身的感觉"时，你会发现冲动的力量开始消散。</p>
`,
    category: 'xinli-tiaojie',
    categoryName: '心理调节',
    author: '戒色指南编辑部',
    date: '2026-07-28',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20meditation%20space%20with%20a%20single%20candle%20burning%2C%20soft%20diffused%20light%2C%20minimalist%20zen%20interior%2C%20warm%20beige%20walls%2C%20bamboo%20mat%20on%20wooden%20floor%2C%20calm%20and%20serene%20atmosphere%2C%20mindfulness%20concept%2C%20editorial%20photography&width=800&height=450&seq=jiese-article-6&orientation=landscape',
    tags: ['正念', '冥想', '觉知'],
    featured: false,
  },
  {
    id: '7',
    slug: 'jiese-yinshi-yundong-peihe',
    title: '戒色期间的运动与饮食配合方案',
    excerpt: '身体的能量需要有健康的出口。合理的运动和饮食计划能让戒色之路事半功倍。',
    content: `
<h2>为什么运动是戒色的最佳盟友？</h2>
<p>当你戒色时，身体积累的性能量需要健康的释放途径。运动不仅提供了这个途径，还能：</p>
<ul>
<li>提升内啡肽水平，缓解戒断期的焦虑和抑郁。</li>
<li>改善睡眠质量，加速大脑修复。</li>
<li>增强睾酮利用效率，而不是让它在体内"淤积"。</li>
</ul>

<h2>推荐的运动方案</h2>
<ul>
<li><strong>晨间有氧（20-30分钟）：</strong>慢跑、快走或跳绳。在睾酮水平最高的早晨进行有氧运动效果最佳。</li>
<li><strong>下午力量训练（30-45分钟）：</strong>俯卧撑、深蹲、引体向上等自重训练。不需要健身房，在家就能完成。</li>
<li><strong>晚间拉伸（10分钟）：</strong>帮助身体放松，为高质量睡眠做准备。</li>
</ul>

<h2>饮食建议</h2>
<ul>
<li><strong>增加优质蛋白：</strong>鸡蛋、鱼肉、鸡胸肉，帮助肌肉恢复。</li>
<li><strong>补充锌元素：</strong>南瓜籽、牡蛎、坚果，支持睾酮代谢平衡。</li>
<li><strong>减少精制糖：</strong>高糖饮食会导致血糖波动，间接增加冲动风险。</li>
<li><strong>充足饮水：</strong>每天2-3升水，脱水状态会降低自控力。</li>
</ul>
`,
    category: 'jiese-fangfa',
    categoryName: '戒色方法',
    author: '戒色指南编辑部',
    date: '2026-07-25',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Healthy%20meal%20prep%20and%20workout%20equipment%20on%20a%20clean%20minimalist%20surface%2C%20fresh%20vegetables%20and%20fruits%2C%20dumbbells%20and%20yoga%20mat%2C%20natural%20morning%20light%2C%20warm%20beige%20tones%2C%20healthy%20lifestyle%20concept%2C%20flat%20lay%20food%20photography&width=800&height=450&seq=jiese-article-7&orientation=landscape',
    tags: ['运动', '饮食', '身体健康'],
    featured: false,
  },
  {
    id: '8',
    slug: 'jiese-shejiao-meiti-jianyi',
    title: '社交媒体戒断：打造无触发数字环境',
    excerpt: '在这个算法推荐的时代，社交媒体是最容易触发破戒的环境之一。教你系统化地净化你的数字空间。',
    content: `
<h2>算法是你的敌人</h2>
<p>现代社交媒体的推荐算法经过精心设计，目的就是最大化你的停留时间。当算法检测到你对某些视觉刺激有反应时，它会不断推送更多类似内容。这形成了一个危险的恶性循环。</p>

<h2>系统性数字净化方案</h2>

<h3>第一阶段：清理（第1-2天）</h3>
<ul>
<li>取关所有可能触发冲动的账号。</li>
<li>删除浏览历史和搜索记录。</li>
<li>在平台设置中关闭个性化推荐。</li>
</ul>

<h3>第二阶段：限制（第3-7天）</h3>
<ul>
<li>将社交媒体使用时间限制在每天30分钟以内。</li>
<li>使用手机自带的屏幕使用时间功能设定限制。</li>
<li>在晚上9点后完全不使用社交媒体。</li>
</ul>

<h3>第三阶段：替代（第8天开始）</h3>
<ul>
<li>用阅读类App替代社交媒体的碎片时间。</li>
<li>关注教育、科技、健康等正面内容的创作者。</li>
<li>培养线下社交习惯，减少对数字社交的依赖。</li>
</ul>
`,
    category: 'jiese-fangfa',
    categoryName: '戒色方法',
    author: '戒色指南编辑部',
    date: '2026-07-22',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20placed%20face%20down%20on%20a%20minimalist%20wooden%20desk%20next%20to%20a%20book%20and%20a%20cup%20of%20tea%2C%20soft%20natural%20light%20from%20window%2C%20digital%20detox%20concept%2C%20calm%20and%20peaceful%20atmosphere%2C%20warm%20beige%20and%20cream%20tones%2C%20editorial%20still%20life&width=800&height=450&seq=jiese-article-8&orientation=landscape',
    tags: ['社交媒体', '数字净化', '环境管理'],
    featured: false,
  },
  {
    id: '9',
    slug: 'jiese-fuqin-jiating-xiufu',
    title: '戒色与家庭关系修复：一位父亲的真诚告白',
    excerpt: '过度的色情消费不仅伤害自己，也在无形中伤害着最亲近的人。听一位父亲讲述他的救赎之路。',
    content: `
<h2>一个父亲的忏悔</h2>
<p>"我曾经以为只要不被发现，就没有人受伤。但我错了。"张先生（化名），42岁，两个孩子的父亲，在接受采访时说道。</p>

<h2>Q：你是如何意识到问题严重性的？</h2>
<p>"那天我女儿问我：'爸爸你为什么总是不开心？'一个7岁的孩子看出来的东西，我自己竟然没有察觉。那一刻我突然意识到，我所谓的'私人娱乐'正在偷走我对家人的爱和注意力。"</p>

<h2>Q：戒色后家庭关系有什么变化？</h2>
<p>"最大的变化是我的'在场感'。以前虽然人坐在客厅里，但心思不知道飘到哪里去了。现在我能真正地陪孩子玩游戏，和妻子聊天时也能认真倾听。这些听起来很简单，但对于之前的我来说，真的做不到。"</p>

<h2>Q：对同样处境的人有什么建议？</h2>
<p>"想象一下：如果你把每天花在色情上的30分钟，用来陪孩子读一本书，用来和妻子散步聊天，一年下来会积累多少美好的回忆？不要让虚幻的画面偷走真实的人生。"</p>
`,
    category: 'chenggong-anli',
    categoryName: '成功案例',
    author: '戒色指南编辑部',
    date: '2026-07-19',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20father%20reading%20a%20book%20with%20his%20young%20daughter%20in%20a%20cozy%20sunlit%20living%20room%2C%20warm%20family%20moment%2C%20soft%20natural%20light%2C%20minimalist%20home%20interior%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20emotional%20connection%20concept%2C%20editorial%20lifestyle%20photography&width=800&height=450&seq=jiese-article-9&orientation=landscape',
    tags: ['家庭', '亲子关系', '成功案例'],
    featured: false,
  },
  {
    id: '10',
    slug: 'jiese-jianchi-da-jiqiao',
    title: '戒色坚持不下去？试试这5个立竿见影的技巧',
    excerpt: '戒色路上每个人都会遇到瓶颈期。这5个经过验证的实用技巧，能在你最想放弃的时候拉你一把。',
    content: `
<h2>当意志力耗尽时，你需要的是"技巧"</h2>
<p>意志力像肌肉一样，会疲劳。当你压力大、疲惫、孤独的时候，就是意志力最脆弱的时候——也恰恰是冲动最强的时候。以下5个技巧不需要消耗意志力，可以在关键时刻自动启动。</p>

<h2>技巧一：冷水刺激法</h2>
<p>当强烈冲动来袭时，立即用冷水洗脸或冲一个冷水澡（哪怕只有30秒）。冷水会激活副交感神经系统，迅速"重启"你的生理状态，冲动通常会在30秒内大幅减弱。</p>

<h2>技巧二：5-4-3-2-1 感官接地法</h2>
<p>这是源于创伤治疗的一种技术，对中断冲动非常有效：</p>
<ul>
<li>说出你看到的<strong>5</strong>样东西。</li>
<li>说出你能触摸到的<strong>4</strong>样东西。</li>
<li>说出你能听到的<strong>3</strong>种声音。</li>
<li>说出你能闻到的<strong>2</strong>种气味。</li>
<li>说出你能尝到的<strong>1</strong>种味道。</li>
</ul>

<h2>技巧三：延迟15分钟</h2>
<p>告诉自己："我可以看，但等一下——先等15分钟。"在等待期间，去做任何其他事情。大多数冲动在15分钟内会自然消退。</p>

<h2>技巧四：视觉锚点</h2>
<p>准备一张代表你戒色目标的照片或文字（比如家人的照片、自己写下的承诺书），在冲动时拿出来看一看。视觉锚点能迅速将你拉回理智状态。</p>

<h2>技巧五：紧急联系人</h2>
<p>提前约定一位信得过的朋友作为"紧急联系人"。在冲动最强烈的时候，立刻给他发消息或打电话，不需要聊戒色的事情——任何对话都有助于打破孤立感。</p>
`,
    category: 'jiese-fangfa',
    categoryName: '戒色方法',
    author: '戒色指南编辑部',
    date: '2026-07-16',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20splashing%20cold%20water%20on%20their%20face%20at%20a%20minimalist%20bathroom%20sink%2C%20clean%20white%20ceramic%2C%20natural%20light%20from%20window%2C%20refreshing%20and%20energizing%20mood%2C%20warm%20beige%20walls%2C%20self%20care%20concept%2C%20editorial%20photography%20style&width=800&height=450&seq=jiese-article-10&orientation=landscape',
    tags: ['实用技巧', '坚持', '应急方法'],
    featured: false,
  },
];

export const faqs = [
  {
    question: '戒色多少天能看到效果？',
    answer: '一般来说，7天后精力开始回升，21天后专注力明显改善，60-90天后大脑奖励系统基本恢复正常。但每个人的情况不同，关键在于持续坚持而不是追求一个特定的天数。',
  },
  {
    question: '戒色后身体会有哪些变化？',
    answer: '常见的积极变化包括：精力提升、睡眠质量改善、皮肤状态变好、专注力增强、社交自信提升、焦虑感下降。这些变化通常在戒色后2-4周开始显现。',
  },
  {
    question: '戒色失败了怎么办？不要自责！',
    answer: '戒色失败是非常正常的，几乎每个人都经历过。关键是不要把一次破戒定义为"失败"，而是把它看作学习的机会。分析触发因素，调整策略，然后重新开始。你比昨天多坚持了一天，这就是进步。',
  },
  {
    question: '需要完全戒除自慰行为吗？',
    answer: '医学上的建议是"适度"。问题的核心不是行为本身，而是"失控"——当你发现自己无法控制频率、影响到日常生活和心理健康时，才需要干预。本指南的"戒色"更多指的是戒除强迫性的、失控的色情消费行为。',
  },
  {
    question: '有没有推荐的戒色工具或App？',
    answer: '市面上有一些专注力训练和习惯养成的App可以作为辅助工具。但我们更推荐的是建立一个健康的日常生活结构：固定的作息、规律的运动、有意义的社交活动，这些比任何App都更有效。',
  },
  {
    question: '戒色会影响性功能吗？',
    answer: '长期过度的色情消费反而可能导致实际的性功能障碍（如PIED - 色情诱导的勃起功能障碍）。适度戒色有助于恢复正常的性反应模式。但完全禁欲也不是目标，关键是建立健康的性观念和行为模式。',
  },
];

export const testimonials = [
  {
    name: '小陈',
    days: 180,
    quote: '戒色180天后，我终于找回了对生活的掌控感。工作效率翻倍，和女朋友的关系也变得更好了。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20with%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20friendly%20expression%2C%20business%20casual%20attire&width=80&height=80&seq=avatar-1&orientation=squarish',
  },
  {
    name: '大刘',
    days: 120,
    quote: '最直观的变化是早上起床不再困难了。以前每天闹钟响5遍都起不来，现在6点自然醒。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20man%20in%20his%2030s%20with%20confident%20look%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20modern%20professional%20portrait&width=80&height=80&seq=avatar-2&orientation=squarish',
  },
  {
    name: '阿杰',
    days: 90,
    quote: '戒色的过程让我学会了自律，这种自律已经蔓延到了生活的方方面面——健身、阅读、早睡。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20with%20bright%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20energetic%20and%20positive%20expression&width=80&height=80&seq=avatar-3&orientation=squarish',
  },
  {
    name: '老周',
    days: 60,
    quote: '60天了，我觉得自己像换了一个人。以前不敢看别人眼睛，现在和人交流非常自然。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Asian%20man%20in%20his%2040s%20with%20wise%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20mature%20and%20calm%20portrait&width=80&height=80&seq=avatar-4&orientation=squarish',
  },
];

export const aboutInfo = {
  brandName: '戒色完全指南',
  description: '戒色完全指南成立于2024年，是一个专注于科学戒色方法研究和传播的公益平台。我们致力于为有戒色需求的人群提供科学、系统、有效的戒色指导，帮助每一位来访者实现身心健康和人生重建。',
  mission: '用科学的方法帮助100万人走出色情成瘾的困境，重建自律、自信、自爱的生活。',
  values: [
    { title: '科学为本', description: '所有方法均基于认知行为科学、神经科学和心理学实证研究。' },
    { title: '尊重隐私', description: '我们深知戒色话题的敏感性，严格保护每一位用户的隐私。' },
    { title: '实用导向', description: '不空谈理论，每一条建议都经过实践验证，可直接落地执行。' },
    { title: '社群互助', description: '相信"一个人走得快，一群人走得远"，鼓励社群互助与经验分享。' },
  ],
  contact: {
    email: 'contact@jiesezhinan.com',
    wechat: 'jiesezhinan2024',
    qqGroup: '123456789',
  },
};